import { createTheme } from "@mui/material/styles";
import { Colors, GreyPallet } from "./styles";

type GreyOptions = {
  black: string;
  light: string;
  regular: string;
  lightGhost: string;
  regularGhost: string;
};

declare module "@mui/material/styles" {
  interface Theme {
    bus: {
      Direto: string;
      Inverso: string;
      Cet: string;
      Reitoria: string;
    };
    overrides: {};
    root: {};
  }

  interface ThemeOptions {
    bus?: {
      Direto?: string;
      Inverso?: string;
      Cet?: string;
      Reitoria?: string;
    };
    overrides?: {};
    root?: {};
  }

  interface Palette {
    Direto: Palette["primary"];
    Inverso: Palette["primary"];
    Cet: Palette["primary"];
    Reitoria: Palette["primary"];
    Grey: Palette["primary"];
  }

  interface PaletteOptions {
    Direto: PaletteOptions["primary"];
    Inverso: PaletteOptions["primary"];
    Cet: PaletteOptions["primary"];
    Reitoria: PaletteOptions["primary"];
    Grey: GreyOptions;
  }
}

const theme = createTheme({
  bus: {},
  typography: {
    fontFamily: "Inter, sans-serif",
    // fontFamily: "Nunito, Roboto",
  },
  palette: {
    primary: {
      main: Colors.Primary,
    },
    secondary: {
      main: Colors.Secondary,
    },
    Direto: { main: Colors.Direto },
    Inverso: { main: Colors.Inverso },
    Cet: { main: Colors.Cet },
    Reitoria: { main: Colors.Reitoria },

    Grey: {
      black: GreyPallet.Black,
      light: GreyPallet.Light,
      regular: GreyPallet.Regular,

      lightGhost: GreyPallet.LightGhost,
      regularGhost: GreyPallet.RegularGhost,
    },
  },
  overrides: {
    MuiAccordionSummary: {
      root: {
        backgroundColor: `${Colors.Primary} !important`,
      },
    },
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "15px",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
        },
      },
    },
  },
});

export default theme;
